export default "__VITE_ASSET__BvZRjFVL__"